<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-5 col-sm-8">
          <h5>Exam Grades</h5>
        </div>
        <div class="col-7 col-sm-4 text-right">
          <add-exam-grade @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <exam-grade-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExamGradeTable from '@/components/exam/grades/Table/index'
import AddExamGrade from '@/components/exam/grades/Forms/Add/index'

export default {
  components: {
    ExamGradeTable,
    AddExamGrade,
  },
  mounted: function() {
    this.getGradeGroup()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  methods: {
    getGradeGroup: function() {
      this.loading = true
      this.$http.get('/api/gradegroup', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getGradeGroup()
    },
    handleUpdateTable: function() {
      this.getGradeGroup()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getGradeGroup()
    },
    onChange(current) {
      this.current = current
      this.getGradeGroup()
    },
  },
}
</script>
